import React, { useContext, useEffect, useState } from 'react';

import NumberFormat from 'react-number-format';
import AppContext from '../../../context';

import './number.component.css';

function Number(props) {
  const context = useContext(AppContext);
  const [isMob, setIsMob] = useState(true);

  useEffect(() => {
    //responsive
    let timeoutId = null;
    const onResize = () => {
      clearTimeout(timeoutId);
      timeoutId = setTimeout(() => {
        if (window.innerWidth < 440) {
          setIsMob(true);
        } else {
          setIsMob(false);
        }
      }, 50);
    };
    onResize();
    window.addEventListener('resize', onResize);
    return () => {
      window.removeEventListener('resize', onResize);
    };
  }, []);

  const show_decimals = props.show_decimals;
  let prefix = null;
  if (props.usePrefix) {
    prefix = context.currencyPrefix;
  }

  const format = (value) => {
    if (isMob) {
      if (Math.abs(props.value) >= 1e7) {
        return `${(props.value / 1e7).toFixed(2)} Crs`;
      }
      if (Math.abs(props.value) >= 1e5) {
        return `${(props.value / 1e5).toFixed(2)} L`;
      }
      return value;
    } else if (props.isFormatWeb) {
      if (Math.abs(props.value) >= 1e7) {
        return `${(props.value / 1e7).toFixed(2)} Crs`;
      }
      if (Math.abs(props.value) >= 1e5) {
        return `${(props.value / 1e5).toFixed(2)} Lakhs`;
      }
      return value;
    } else {
      return value;
    }
  };

  const roundToPoints = (value, points) => {
    return parseFloat(value.toFixed(points));
  };

  return (
    <NumberFormat
      value={
        show_decimals
          ? !props.points
            ? props.value
            : roundToPoints(props.value, props.points)
          : Math.round(props.value)
      }
      displayType={'text'}
      thousandSeparator={true}
      thousandsGroupStyle="lakh"
      prefix={prefix}
      renderText={(value) => (props.format ? format(value) : value)}
    />
  );
}

export default Number;
